import { buttonColorVariantSchema, buttonConfigurationSchema } from '@doss/common-all'

/**
 * Checks if a button configuration indicates a destructive action.
 * Parses the button configuration and checks if the color variant is DESTRUCTIVE.
 */
export const isButtonDestructive = (button: { buttonConfiguration?: unknown }): boolean => {
  if (!button.buttonConfiguration) {
    return false
  }

  const configToParse =
    typeof button.buttonConfiguration === 'string'
      ? JSON.parse(button.buttonConfiguration)
      : button.buttonConfiguration

  const parseResult = buttonConfigurationSchema.safeParse(configToParse)
  return parseResult.success
    ? parseResult.data.colorVariant === buttonColorVariantSchema.enum.DESTRUCTIVE
    : false
}
